import { render, staticRenderFns } from "./Provincia.vue?vue&type=template&id=1a903296"
import script from "./Provincia.vue?vue&type=script&lang=js"
export * from "./Provincia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports